export default __webpack_public_path__ + "static/media/img-0129-germany-full-face.d7ee8713.png";